import { Button } from 'antd';
import type { FormInstance } from 'antd';
import { CaseSidebarItemId } from 'components/CaseSidebar/types';
import { FormValidationContext } from 'hooks';
import { useContext } from 'react';
import { useIntl } from 'react-intl';

interface OoCaseFormFooterProps {
  previousSection?: CaseSidebarItemId;
  nextSection?: CaseSidebarItemId;
  previousLabel?: string;
  nextLabel?: string;
  onNavigate: (itemId: CaseSidebarItemId) => void;
  form?: FormInstance;
  isFormEditable?: boolean;
}

export function OoCaseFormFooter({
  previousSection,
  nextSection,
  previousLabel,
  nextLabel,
  onNavigate,
  form,
  isFormEditable,
}: OoCaseFormFooterProps) {
  const { formatMessage } = useIntl();
  const formValidationContext = useContext(FormValidationContext);
  const showForwardAction = Boolean(form) || Boolean(nextSection);

  if (!previousSection && !showForwardAction) {
    return null;
  }

  const submitButtonLabel = nextLabel ?? (form && !nextSection ? formatMessage({ id: 'common.saveContinue' }) : 'Next');

  return (
    <div className='absolute bottom-0 right-0 z-10 mt-4 flex w-full justify-between gap-8 rounded-lg border border-solid border-white bg-gray-500/10 p-2 backdrop-blur-md'>
      <span className='flex gap-2'>
        {previousSection && (
          <Button size='large' key='back' onClick={() => onNavigate(previousSection)}>
            {previousLabel ?? 'Back'}
          </Button>
        )}
      </span>
      {isFormEditable && showForwardAction && (
        <span className='flex gap-2'>
          <Button
            size='large'
            type='primary'
            key='next'
            htmlType={form ? 'submit' : 'button'}
            loading={formValidationContext?.isSubmitting}
            onClick={!form && nextSection ? () => onNavigate(nextSection) : undefined}
          >
            {submitButtonLabel}
          </Button>
        </span>
      )}
      {!isFormEditable && nextSection && (
        <span className='flex gap-2'>
          <Button size='large' type='primary' key='next' onClick={() => onNavigate(nextSection)}>
            {nextLabel ?? 'Next'}
          </Button>
        </span>
      )}
    </div>
  );
}
